// @mui
import { Card, Container, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import staticLoader from '@utils/staticLoader';
import { m } from "framer-motion";
import NextImage from "next/image";
import { MotionViewport, varFade } from 'src/components';
// ----------------------------------------------------------------------

const VISIONS = [
  {
    name: 'Kunden i fokus',
    description:
      'Gjennom årene har våre lojale kunder hjulpet oss til å vokse, og i dyp takknemlighet vil vi alltid sette deg først.',
  },
  {
    name: 'Bransjeerfaring',
    description: 'Med over 20 års bransjeerfaring har vi kontinuerlig utviklet vår kompetanse.',
  },
  {
    name: 'Høye standarder og lave kostnader',
    description: 'Du bør aldri forvente noe annet enn det beste fra våre elektrikere.',
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(8, 0),
  },
}));

// ----------------------------------------------------------------------

export default function AboutOurVision() {

  return (
    <RootStyle>
      <Container>
        <Stack
          component={MotionViewport}
          spacing={3}
          sx={{
            maxWidth: 466,
            mb: { xs: 8, md: 5 },
            mx: { xs: 'auto', md: 'unset' },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography variants={varFade().in} component={m.h2} variant="h2">Hvorfor velge Bergen Elektro Automasjon?</Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Vårt mål er å levere fremtidsrettede løsninger som gjør at våre kunder reduserer eller effektiviserer forbruk.
            Vi streber etter null utslipp på våre byggeplasser og vi reduserer overforbruk til et minimum. <br />
          </Typography>
        </Stack>
        <Grid
          container
          spacing={{ xs: 8, md: 3 }}
          justifyContent="space-between"
          alignItems={{ md: 'center' }}
        >
          <Grid item xs={12} md={6} lg={5} height={1} position="relative">
            <NextImage loader={staticLoader} layout="responsive" height="100%" width="100%" objectFit="contain" alt="vision" src="/static/illustrations/illustration_vision.svg" />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Stack
              sx={{
                position: 'relative',
              }}
              alignItems={{ md: 'flex-end' }}
            >
              {VISIONS.map((vision, index) => {
                const { name, description } = vision;
                const firstVision = index === 0;
                const secondVision = index === 1;
                const thirdVision = index === 2;

                return (
                  <Card
                    key={name}
                    sx={{
                      p: 4,
                      mt: 4,
                      width: { md: 'calc(50% - 16px)' },
                      ...(firstVision && {
                        top: { md: 0 },
                        left: { md: 0 },
                        bottom: { md: 0 },
                        my: { md: 'auto' },
                        boxShadow: { md: 0 },
                        maxHeight: { md: 304 },
                        display: { md: 'flex' },
                        position: { md: 'absolute' },
                        flexDirection: { md: 'column' },
                        justifyContent: { md: 'center' },
                      }),
                      ...(secondVision && {
                        boxShadow: (theme) => ({ md: theme.customShadows.z24 }),
                      }),
                      ...(thirdVision && {
                        boxShadow: { md: 0 },
                      }),
                    }}
                  >
                    <Typography
                      variant="h1"
                      component="h2"
                      sx={{ color: 'text.disabled', opacity: 0.24, mb: 3 }}
                    >
                      {`0${index + 1}`}
                    </Typography>

                    <Typography variant="h4" paragraph>
                      {name}
                    </Typography>

                    <Typography sx={{ color: 'text.secondary' }}>{description}</Typography>
                  </Card>
                );
              })}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
